import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21501 20595"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:291.735}.fil0{fill:#000}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path id="XMLID_488_" d="M10751 146h-1z" className="fil0 " />
      <g id="_2283924809952">
        <path
          id="XMLID_328_"
          d="m11050 10988 9435-3066h-7208l-2227-6854z"
          className="fil0 "
        />
        <path
          id="XMLID_489_"
          d="m14839 12728 5831-4236-9435 3065 5831 8026z"
          className="fil0 "
        />
        <path
          id="XMLID_490_"
          d="m10750 11909-5830 8026 5831-4236 5830 4236z"
          className="fil0 "
        />
        <path
          id="XMLID_491_"
          d="M10451 10988V1068L8224 7922H1016z"
          className="fil0 "
        />
        <path
          id="XMLID_492_"
          d="m4435 19583 5831-8026L832 8492l5830 4236z"
          className="fil0 "
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
